<template>
  <div>
    <div class="" style="color:#869fac">
      <p style="margin-bottom:2px">선택한 <span style="font-weight:600;color:#000">미디어, 채널, 비히클의 Output 타겟</span>을 설정합니다.</p>
      <p>타겟을 설정하지 않을 경우, 전체 모수를 기준으로 도달율이 계산됩니다.</p>
    </div>
    <div id="genderGroup" class="" style="padding-top:15px">
      <b-button-group>
        <b-button :id="id+'MF'" pressed variant="outline-info" class="btn-pill btn-age-group-lg" @click="formData.gender='MF';demographicCount();">전체</b-button>
        <b-button :id="id+'M'"  variant="outline-info" class="btn-pill btn-age-group-lg"         @click="formData.gender='M';demographicCount();">남자</b-button>
        <b-button :id="id+'F'"  variant="outline-info" class="btn-pill btn-age-group-lg"         @click="formData.gender='F';demographicCount();">여자</b-button>
      </b-button-group>
    </div>
    <div style="padding-top:10px">
      <b-row>
        <b-col sm="1"></b-col>
        <b-col sm="2" style="margin-top:5px;text-align:center;">
          <b>MIN</b>
          <b-form-input type="number" min=0 v-bind:max="maxAge" v-model="minAge" placeholder="MIN"></b-form-input>
        </b-col>
        <b-col sm="2" style="margin-top:5px;text-align:center;">
          <b>MAX</b>
          <b-form-input type="number" v-bind:min="minAge" max=100 v-model="maxAge" placeholder="MAX"></b-form-input>
        </b-col>
        <b-col sm="4" style="padding-top:10px;padding-bottom:0px;">
          <div class="text-white" style="background-color:#63c2de;border:1px solid #428bca;border-radius:7px;">
            <div style="font-size:24px;padding:0.5rem;text-align:center">
                {{resultMin}}세 ~ {{resultMax}}세
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="" style="color:#869fac;padding-top:30px;">
      <b-row>
        <b-col sm="5" style="text-align:right">
          <p>위 선택 조건에 대한
            <span style="font-weight:600;color:#000">대상 모집단 인구수</span>
          </P>
        </b-col>
        <b-col sm="5">
          <span style="font-size:20px;font-weight:600;color:#151b1e">
            {{formData.gender | genderChar}} | {{resultMin}}~{{resultMax}} | 총 {{formData.demographic_cnt | thousands}}명
          </span>
        </b-col>
      </b-row>
    </div>
    <hr>
    <div style="font-size:22px;font-weight:600;">
      주요타겟
    </div>
    <div id="ageGroup" style="padding-top:10px;">
      <b-button :id="id+769" variant="outline-danger" class="btn-pill btn-age-group-sm active" @click="formData.age='769';ageSelect();">전체</b-button>
      <b-button :id="id+1329" variant="outline-success" class="btn-pill btn-age-group-sm"      @click="formData.age='1329';ageSelect();">13~29</b-button>
      <b-button :id="id+1339" variant="outline-success" class="btn-pill btn-age-group-sm"      @click="formData.age='1339';ageSelect();">13~39</b-button>
      <b-button :id="id+1929" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='1929';ageSelect();">19~29</b-button>
      <b-button :id="id+1934" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='1934';ageSelect();">19~34</b-button>
      <b-button :id="id+1939" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='1939';ageSelect();">19~39</b-button>
      <b-button :id="id+1949" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='1949';ageSelect();">19~49</b-button>
      <b-button :id="id+1969" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='1969';ageSelect();">19~69</b-button>
      <b-button :id="id+2534" variant="outline-success" class="btn-pill btn-age-group-sm"      @click="formData.age='2534';ageSelect();">25~34</b-button>
      <b-button :id="id+2544" variant="outline-success" class="btn-pill btn-age-group-sm"      @click="formData.age='2544';ageSelect();">25~44</b-button>
      <b-button :id="id+3039" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='3039';ageSelect();">30~39</b-button>
      <b-button :id="id+3049" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='3049';ageSelect();">30~49</b-button>
      <b-button :id="id+3059" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='3059';ageSelect();">30~59</b-button>
      <b-button :id="id+3069" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='3069';ageSelect();">30~69</b-button>
      <b-button :id="id+3544" variant="outline-success" class="btn-pill btn-age-group-sm"      @click="formData.age='3544';ageSelect();">35~44</b-button>
      <b-button :id="id+4049" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='4049';ageSelect();">40~49</b-button>
      <b-button :id="id+4059" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='4059';ageSelect();">40~59</b-button>
      <b-button :id="id+4069" variant="outline-success" class="btn-pill btn-age-group-sm"      @click="formData.age='4069';ageSelect();">40~69</b-button>
      <b-button :id="id+5059" variant="outline-primary" class="btn-pill btn-age-group-sm"      @click="formData.age='5059';ageSelect();">50~59</b-button>
      <b-button :id="id+6069" variant="outline-success" class="btn-pill btn-age-group-sm"      @click="formData.age='6069';ageSelect();">60~69</b-button>
    </div>

    <div slot="modal-footer" class="w-100">
      <br>
      <div class="searched-block" style="color:#869fac;font-size:12px;">
        * 위 모수는 닐슨코리아의 싱글소스 데이터의 전체 인구 통계학적인 모수를 기준으로 하고 있습니다.
      </div>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral';
import reachFormData from "./ReachFormData.js";
export default {
    name: "Target",
    filters:{
      thousands : function (value) {
        return numeral(value).format('0,0');
      },
      genderChar : function (value) {
        var result = '남녀'
        if(value == 'MF'){
          result = '남녀';
        }else if(value == 'M'){
          result = '남자';
        }else if(value == 'F'){
          result = '여자';
        }
        return result;
      }
    },
    components:{
    },
    props: {
      formData:null,
    },
    data() {
        return {
          id: '',
          demographics: new Map(),
          activeButton: this._uid + '_769',
          resultMin: '7',
          resultMax: '69',
          minAge: 7,
          maxAge: 69,
        }
    },
    watch:{
      'minAge': function() {
        this.calcAge();
        this.demographicCount();
      },
      'maxAge': function() {
        this.calcAge();
        this.demographicCount();
      }
    },
    created: function() {
      this.id = this._uid + "_";
    },
    mounted() {
      var result = this.$session.get('demographics');
      for (var i = 0; i < result.length; i++) {
        this.demographics.set(result[i].dmgrph_CD, result[i].dmgrph_CNT);
      }

      $(".btn-group > .btn").click(function() { // 남녀 성별 버튼 active 처리
        $(this).addClass("active").siblings().removeClass("active");
      });
    },
    methods:{
      historyTarget(){
        if(this.formData.gender === 'M'){
          document.getElementById(this.id + 'M').click();
        }else if(this.formData.gender === 'F'){
          document.getElementById(this.id + 'F').click();
        }
        this.minAge = this.formData.minAge;
        this.maxAge = this.formData.maxAge;;
      },
      historyTargetForMediaTemplate(historyFormData){
        if(historyFormData.gender === 'M'){
          document.getElementById(this.id + 'M').click();
        }else if(historyFormData.gender === 'F'){
          document.getElementById(this.id + 'F').click();
        }
        this.minAge = historyFormData.minAge;
        this.maxAge = historyFormData.maxAge;
      },
      disableTarget(){
        document.getElementById(this.id+"MF").click();
        document.getElementById(this.id+"769").click();
      },
      demographicCount() {
        // 1. 모수 셀렉팅
        this.demographic_cnt = this.demographics.get(this.formData.gender + this.formData.age); // 모수 셀렉팅
        this.formData.demographic_cnt = this.demographics.get(this.formData.gender + this.formData.age); // 모수 셀렉팅
        // 변수값 조정 화면에 보여지는 것과 코드형태의 차이때문
        var gender = '';
        var age = '';
        // 액티브 버튼 조정
        if (this.activeButton != (this.id + this.formData.age)) {
          try {
            document.getElementById(this.activeButton).className = document.getElementById(this.activeButton).className.replace("active", "");
          }catch(exception){}
          this.activeButton = (this.id + this.formData.age);
          try {
            document.getElementById(this.activeButton).className += " active";
          }catch(exception){}
        }
        // 성별 라벨 조립
        this.formData.targetCode = this.formData.gender + this.formData.age;
        this.formData.genderLabel = this.formData.gender + this.formData.age;
        this.formData.gender = this.formData.gender; // 2018-10-31
        this.formData.age = this.formData.age; // 2018-10-31
        this.$log.debug('[Target ' + this.id+'] 타겟변경 : ', this.formData.targetCode, this.formData.genderLabel);
        // end 타겟 관련
      },
      ageSelect() {
        if (this.formData.age == '769') {
          this.minAge = this.formData.age.slice(0, 1);
          this.maxAge = this.formData.age.slice(1);
        } else {
          this.minAge = this.formData.age.slice(0, 2);
          this.maxAge = this.formData.age.slice(2);
        }
        this.formData.minAge = this.minAge;
        this.formData.maxAge = this.maxAge;
      },
      calcAge() {
        var ageList = this.$_.clone(reachFormData.ageList);
        var tMin = this.minAge;
        var tMax = this.maxAge;
        for (var i = 0; i < ageList.length; i++) {
          ageList[i].point = Math.abs(ageList[i].min - tMin) + Math.abs(ageList[i].max - tMax);

          if (ageList[i].min == 7) {
            if (tMax < 60) {
              ageList[i].point = 999;
            }
          }
        }
        var test = this.$_.sortBy(ageList, 'point');
        this.resultMin = String(test[0].min);
        this.resultMax = String(test[0].max);
        this.formData.minAge = this.resultMin;
        this.formData.maxAge = this.resultMax;
        this.formData.age = this.resultMin.concat(this.resultMax);
        this.formData.targetCode = this.formData.gender + this.formData.age;
      },
    }
}
</script>
<style scoped>
#genderGroup .btn.active {
  color: #fff;
  border: 1px solid #428bca !important;
}

#ageGroup .btn.active {
  color: #fff;
  border: 1px solid #049372 !important;
}

.btn-age-group-lg {
  width: 234px;
  margin-right: 11px;
  font-weight: 600;
}

.btn-age-group-sm {
  width: 65px;
  margin-right: 5px;
  margin-bottom: 3px;
  font-weight: 600;
}

.CSSAnimationChart,
.mapChart {
    width: 100%;
    height: 420px
}
</style>



// WEBPACK FOOTER //
// src/views/common/reachTarget.vue